export const CLIENT_DEVICE_INFO_FIELDS = [
  { key: 'os', label: 'OS' },
  { key: 'os_version', label: 'OS Version' },
  { key: 'app_version', label: 'App Version' },
  { key: 'app_build', label: 'App Build' },
  { key: 'email', label: 'Email' },
  { key: 'device_id', label: 'Device ID' },
  { key: 'rc_app_user_id', label: 'RC App User ID' },
  { key: 'country_code', label: 'Country Code' },
  { key: 'device_model', label: 'Device Model' },
  { key: 'device_manufacturer', label: 'Device Manufacturer' },
  { key: 'network_wifi', label: 'Network WiFi' },
  { key: 'network_cellular', label: 'Network Cellular' },
  { key: 'network_carrier', label: 'Network Carrier' },
  { key: 'screen_width', label: 'Screen Width' },
  { key: 'screen_height', label: 'Screen Height' },
];

export const formatDeviceInfoValue = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
};

export const getDeviceInfoFieldValue = (deviceInfo, key) => {
  if (!deviceInfo || typeof deviceInfo !== 'object') return null;
  if (deviceInfo[key] != null && deviceInfo[key] !== '') {
    return formatDeviceInfoValue(deviceInfo[key]);
  }
  const aliases = {
    device_model: ['model'],
    app_version: ['version'],
  };
  const altKeys = aliases[key] || [];
  for (const altKey of altKeys) {
    if (deviceInfo[altKey] != null && deviceInfo[altKey] !== '') {
      return formatDeviceInfoValue(deviceInfo[altKey]);
    }
  }
  return null;
};

export const hasClientDeviceContext = (task) => Boolean(
  task?.client_device_info
  || task?.client_device_id
  || task?.client_country_code
);
